import { useLoading } from "../context/LoadingContext";

export function useAppLoader(minTime = 600) {
  const { setIsLoading } = useLoading();

  const showLoader = () => {
    setIsLoading(true);
    const start = Date.now();

    return () => {
      const elapsed = Date.now() - start;
      const remaining = Math.max(minTime - elapsed, 0);
      setTimeout(() => setIsLoading(false), remaining);
    };
  };

  return { showLoader };
}
